export { default } from './B2BLayout';
